export default "__VITE_ASSET__BVtEvRzU__"